import HeroSearch from './HeroSearch';
import HeroPreviewCard from './HeroPreviewCard';
import TrustBadges from './TrustBadges';
import { t } from '../../utils/i18n';

export default function HeroSection({
  searchMode,
  onSearchModeChange,
  searchQuery,
  onSearchQueryChange,
  onLocationSelect,
  onSearch,
  locationAutocompleteRef,
  children,
}) {
  return (
    <section className="landing-hero relative overflow-visible">
      <div className="landing-container">
        <div className="landing-hero-grid">
          <div className="landing-hero-copy">
            <h1 className="landing-hero-title">
              <span className="block text-[var(--color-text)]">
                {t('landing.hero.title')}
                {' '}
                <span className="landing-hero-accent">{t('landing.hero.titleAccent')}</span>
              </span>
              <span className="block text-[var(--color-text)] mt-1">
                {t('landing.hero.subtitle')}
              </span>
            </h1>

            <p className="landing-hero-subtitle">
              {t('landing.hero.descriptionShort')}
            </p>

            <HeroSearch
              searchMode={searchMode}
              onSearchModeChange={onSearchModeChange}
              searchQuery={searchQuery}
              onSearchQueryChange={onSearchQueryChange}
              onLocationSelect={onLocationSelect}
              onSearch={onSearch}
              locationAutocompleteRef={locationAutocompleteRef}
            />

            <div className="mt-6">
              <TrustBadges />
            </div>
          </div>

          <div className="landing-hero-preview-col hidden lg:block">
            <HeroPreviewCard />
          </div>
        </div>

        <div className="lg:hidden mt-10">
          <HeroPreviewCard />
        </div>
      </div>

      {children && (
        <div className="mt-10 sm:mt-12 px-4 sm:px-6 max-w-[1600px] mx-auto relative z-20 w-full">
          {children}
        </div>
      )}
    </section>
  );
}
